import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const title = process.env.REACT_APP_TAB_TITLE;


// Set the title of the document
document.title = title;

ReactDOM.render(<App />, document.getElementById('root'));

